import moment from 'moment';

export default function dateFormatted(timestamp, format = 'ddd MMM D, YYYY [at] h:mm A') {
  return moment(timestamp).format(format);
}
